import {
  AppBar,
  Toolbar,
  makeStyles,
  Button,
  IconButton,
  Drawer,
  MenuItem,
  Box,
  Container,
  Menu,
  Paper,
  Dialog,
  Avatar,
  Typography,
  Popover,
  Badge,
} from "@material-ui/core";
import { withStyles } from "@material-ui/core/styles";
import CloseIcon from "@material-ui/icons/Close";
import MenuIcon from "@material-ui/icons/Menu";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import React, { useState, useEffect, useRef, useContext } from "react";
import { Link, useHistory, useLocation } from "react-router-dom";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";
import Logo from "./../../component/Logo";
import { NavLink } from "react-router-dom";
import { UserContext } from "src/context/User";
import { AuthContext } from "src/context/Auth";
import { FaBell } from "react-icons/fa";
import Notification from "src/views/pages/Notifications/Notification";
import {SiteModeContext} from "src/context/SiteMode";
import {getMenuForMode,getMenuTo} from "./siteMenus";

const PRIMARY_MENU_COUNT=4;
const DESKTOP_BREAKPOINT=1280;

const useStyles = makeStyles((theme) => ({
  barContainer:{
    maxWidth:"100% !important",
    width:"100%",
    boxSizing:"border-box",
    paddingLeft:"20px !important",
    paddingRight:"20px !important",
    [theme.breakpoints.down("sm")]:{
      paddingLeft:"12px !important",
      paddingRight:"12px !important",
    },
  },
  menuButton:{
    fontSize:"13px",
    lineHeight:"18px",
    fontWeight:600,
    fontFamily:"Open Sans",
    letterSpacing:"0.1px",
    textTransform:"none",
    minWidth:"auto",
    color:"#262626",
    padding:"6px 8px",
    borderRadius:"8px",
    whiteSpace:"nowrap",
    textDecoration:"none",
    position:"relative",
    cursor:"pointer",
    display:"inline-flex",
    alignItems:"center",
    flexShrink:0,
    transition:"color 0.25s ease, background-color 0.25s ease",
    "&::after":{
      content:'""',
      position:"absolute",
      left:"8px",
      right:"8px",
      bottom:"2px",
      height:"2px",
      borderRadius:"2px",
      backgroundColor:"#EC1F24",
      transform:"scaleX(0)",
      transformOrigin:"center",
      transition:"transform 0.3s cubic-bezier(0.22, 1, 0.36, 1)",
    },
    "&:hover":{
      color:"#EC1F24",
      backgroundColor:"rgba(236, 31, 36, 0.06)",
    },
    "&.active":{
      color:"#EC1F24",
    },
    "&.active::after":{
      transform:"scaleX(1)",
    },
    "& .MuiButton-endIcon":{
      marginLeft:"2px",
      transition:"transform 0.25s ease",
    },
    "&.open .MuiButton-endIcon":{
      transform:"rotate(180deg)",
    },
    [theme.breakpoints.down("md")]:{
      fontSize:"13px",
      padding:"6px 7px",
      "&::after":{
        left:"7px",
        right:"7px",
      },
    },
  },
  navLinks:{
    display:"flex",
    alignItems:"center",
    flex:"1 1 auto",
    minWidth:0,
    justifyContent:"flex-end",
    gap:"0px",
    marginRight:"8px",
  },
  logoBox:{
    width:"auto",
    maxWidth:"140px",
    height:"40px",
    flexShrink:0,
    "& img, & svg":{
      maxHeight:"40px",
      width:"auto",
    },
  },
  loginButton:{
    height:"36px",
    padding:"0 16px",
    borderRadius:"8px",
    whiteSpace:"nowrap",
    fontWeight:700,
    textTransform:"none",
    color:"#fff",
    background:"#FF7F26 !important",
    border:"1px solid #FF7F26 !important",
    boxShadow:"0 6px 16px -8px rgba(255, 127, 38, 0.6)",
  },
  morePaper:{
    marginTop:"8px",
    width:"340px",
    borderRadius:"12px",
    padding:"6px",
    border:"1px solid rgba(0, 0, 0, 0.06)",
    boxShadow:"0 18px 40px -16px rgba(0, 0, 0, 0.25)",
  },
  moreItem:{
    display:"flex",
    alignItems:"flex-start",
    gap:"12px",
    padding:"10px 12px",
    borderRadius:"8px",
    whiteSpace:"normal",
    color:"#262626",
    "&:hover":{
      backgroundColor:"rgba(236, 31, 36, 0.06)",
    },
    "&.Mui-selected, &.Mui-selected:hover":{
      backgroundColor:"rgba(236, 31, 36, 0.1)",
    },
    "&:hover .moreIcon, &.Mui-selected .moreIcon":{
      backgroundColor:"#EC1F24",
      color:"#fff",
    },
    "& .moreIcon":{
      width:"34px",
      height:"34px",
      borderRadius:"8px",
      flexShrink:0,
      display:"flex",
      alignItems:"center",
      justifyContent:"center",
      backgroundColor:"rgba(236, 31, 36, 0.1)",
      color:"#EC1F24",
      transition:"background-color 0.2s ease, color 0.2s ease",
      "& svg":{
        fontSize:"19px",
      },
    },
    "& .moreLabel":{
      fontSize:"14px",
      fontWeight:700,
      lineHeight:"20px",
    },
    "& .moreDescription":{
      fontSize:"12px",
      lineHeight:"17px",
      color:"#6B6B6B",
      marginTop:"2px",
    },
  },
  drawerHeader:{
    display:"flex",
    alignItems:"center",
    justifyContent:"space-between",
    width:"100%",
    paddingBottom:"14px",
    marginBottom:"8px",
    borderBottom:"1px solid rgba(0, 0, 0, 0.08)",
  },
  drawerLink:{
    display:"flex",
    alignItems:"center",
    gap:"14px",
    width:"100%",
    padding:"11px 14px",
    borderRadius:"10px",
    color:"#262626",
    fontSize:"15px",
    fontWeight:600,
    textDecoration:"none",
    transition:"background-color 0.2s ease, color 0.2s ease",
    "& svg":{
      fontSize:"20px",
      color:"#8A8A8A",
      transition:"color 0.2s ease",
    },
    "&:hover":{
      backgroundColor:"rgba(236, 31, 36, 0.06)",
      color:"#EC1F24",
      "& svg":{
        color:"#EC1F24",
      },
    },
    "&.active":{
      backgroundColor:"rgba(236, 31, 36, 0.1)",
      color:"#EC1F24",
      "& svg":{
        color:"#EC1F24",
      },
    },
  },
  drawerFooter:{
    marginTop:"auto",
    width:"100%",
    paddingTop:"16px",
    borderTop:"1px solid rgba(0, 0, 0, 0.08)",
    display:"flex",
    flexDirection:"column",
    gap:"10px",
    "& .MuiButton-root":{
      width:"100%",
      marginRight:0,
    },
  },

  toolbar: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    padding: "0 !important",
    minHeight: "48px",
    width: "100%",
    maxWidth: "100%",
    minWidth: 0,
    gap: 8,
    boxSizing: "border-box",
  },
  topbarItmes:{
    display:"flex",
    justifyContent:"flex-end",
    alignItems:"center",
    flex:"1 1 auto",
    minWidth:0,
    maxWidth:"100%",
  },
  actionsCluster:{
    display:"flex",
    alignItems:"center",
    flexShrink:0,
    gap:"8px",
  },
  profileWrap:{
    flexShrink:0,
    cursor:"pointer",
    display:"flex",
    alignItems:"center",
    lineHeight:0,
  },
  profileAvatar:{
    width:36,
    height:36,
    borderRadius:"50%",
    objectFit:"cover",
    display:"block",
    flexShrink:0,
    border:"2px solid #FFFFFF",
    boxShadow:"0 0 0 1.5px #FF7F26",
    backgroundColor:"#F2F2F2",
  },
  profileAvatarFallback:{
    display:"flex",
    alignItems:"center",
    justifyContent:"center",
    boxSizing:"border-box",
    backgroundColor:"#BDBDBD",
    color:"#FFFFFF",
    "& .MuiAvatar-fallback":{
      width:"70%",
      height:"70%",
      margin:0,
    },
  },
  notifyBtn:{
    background:"#0000000D",
    width:36,
    height:36,
    flexShrink:0,
  },

  maindrawer: {
    height: "100%",
    background: "#0c0731",
    width: "260px",
  },
  logoDrawer: {
    width: "140px",
  },
  drawerContainer:{
    padding:"20px 16px",
    height:"100%",
    background:"#ffffff",
    color:"#262626",
    width:"290px",
    maxWidth:"85vw",
    boxSizing:"border-box",
    display:"flex",
    flexDirection:"column",
    justifyContent:"flex-start",
    alignItems:"flex-start",
    gap:"2px",
  },
  drawericon: {
    color: "#000",
    marginLeft: "0px !important",
    marginRight: "0px !important",
    padding: "6px",
    flexShrink: 0,
    fontSize: "25px",
  },
  logoImg: {
    width: "75px",
    margin: " 14px 15px 11px 0px",
    objectFit: "contain",
    "@media (max-width: 500px)": {
      margin: " 11px 1px 3px 0px",
      width: "52px",
      width: "75px",
    },
  },
  menuMobile: {
    fontSize: "16px",
    fontWeight: "500",
    paddingLeft: "10px",
    "@media (max-width: 500px)": {
      padding: "7px 0",
      width: "100%",
    },
  },
  paper1: {
    background: "black",
    color: "white",
  },

  mainHeader: {
    justifyContent: "space-between",
    padding: "0px",
  },
  search: {
    height: "40px",
    position: "relative",
    color: "#ABABAB",
    borderRadius: "100px",
    backgroundColor: "#DAF4FF",
    border: "1px solid #fff",
    marginLeft: 20,
    width: "100%",
    [theme.breakpoints.down("sm")]: {
      marginLeft: "0px",
    },
  },
  searchIcon: {
    fontSize: "16px",
    padding: "0px 9px",
    color: "#000000",
    height: "100%",
    position: "absolute",
    pointerEvents: "none",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },
  inputRoot: {
    color: "inherit",
    fontSize: "16px",
    width: "100%",
  },
  inputInput: {
    padding: "8px 6px 8px 0px",
    fontSize: "12px",
    marginTop: "-2px",
    paddingLeft: `calc(1em + ${theme.spacing(2)}px)`,
    transition: theme.transitions.create("width"),
    width: "100%",
    color: "#000",
    [theme.breakpoints.up("sm")]: {
      width: "100%",
      "&:focus": {
        width: "100%",
      },
    },
  },
  menuButton1: {
    paddingLeft: "0",
  },
  searcBox: {
    backgroundColor: "#DAF4FF",
    borderRadius: " 50px",
  },
  menuMobile1: {
    padding: "15px 0",
    "& h4": {
      fontSize: "14px !important",
      lineHeight: " 17px",
      color: theme.palette.text.main,
      margin: "0 8px",
      fontWeight: "400",
      [theme.breakpoints.only("xs")]: {
        fontSize: "12px !important",
      },
    },
    "& svg": {
      color: theme.palette.text.main,
      "@media (max-width:767px)": {
        display: "none",
      },
    },
    "&:hover": {
      backgroundColor: "transparent",
    },
    "& figure": {
      margin: 0,
      width: 40,
      height: 40,
      borderRadius: "50px",
      overflow: "hidden",
      display: "flex",
      justifyContent: " center",
      alignItems: "center",
      "& img": {
        width: "auto",
        height: "auto",
        maxWidth: "100%",
      },
    },
  },
  menuMobile2: {
    "& h4": {
      fontSize: "14px",
      lineHeight: " 17px",
      color: theme.palette.background.dark,
      margin: "0 5px",
      whiteSpace: "pre",
      fontWeight: "300",
      "@media (max-width:767px)": {
        display: "none",
      },
    },
    "& svg": {
      "@media (max-width:767px)": {
        display: "none",
      },
    },
    "&:hover": {
      backgroundColor: "transparent",
      color: "#ff3965",
    },
  },
  menuMobiledrawer: {
    "& h4": {
      fontSize: "16px",
      lineHeight: " 17px",
      color: "#000",

      whiteSpace: "pre",
      fontWeight: "400",
    },
  },
  searchdiaogBox: {
    "& .MuiDialogContent-root": {
      minHeight: "calc(100vh - 100px)",
      [theme.breakpoints.only("xs")]: {
        padding: "20px 0 !important",
      },
    },
    "& .MuiDialog-paperScrollPaper": {
      overflowY: "auto",
    },
  },
  afterLogin: {
    display: "flex",
    alignItems: "center",
    flexShrink: 0,
    gap: "10px",

    "& .MuiIconButton-root": {
      padding: "0",
      color: theme.palette.text.primary,
    },

    "& p": {
      cursor: "pointer",
    },
  },
  popoverContent: {
    width: "200px",
    height: "auto",
    boxSizing: "border-box",
    padding: "23px 30px 23px 16px",

    "& .icon-and-name": {
      display: "flex",
      alignItems: "center",
      gap: "16px",

      "& p": {
        lineHeight: "35px",
        whiteSpace: "nowrap",
      },
    },
  },
  modeSwitchButton:{
    border:"1.5px solid #FF7F26",
    color:"#FF7F26",
    borderRadius:"8px",
    height:"36px",
    padding:"0 14px",
    marginRight:0,
    whiteSpace:"nowrap",
    fontWeight:700,
    textTransform:"none",
    flexShrink:0,
    minWidth:"auto",
    transition:"background-color 0.3s ease, color 0.3s ease",
    "&:hover":{
      backgroundColor:"#FF7F26",
      color:"#fff",
    },
  },
  modeBadge:{
    marginLeft:"8px",
    padding:"2px 8px",
    borderRadius:"999px",
    backgroundColor:"rgba(236, 31, 36, 0.1)",
    color:"#EC1F24",
    fontSize:"10px",
    fontWeight:700,
    letterSpacing:"0.4px",
    textTransform:"uppercase",
    whiteSpace:"nowrap",
    flexShrink:0,
  },
  logoCluster:{
    display:"flex",
    alignItems:"center",
    flexShrink:0,
    minWidth:0,
  },
}));

export default function Header({fixed=false,onMobileNavOpen}) {
  const location = useLocation();

  const classes = useStyles();
  const [anchorEl1, setAnchorEl1] = useState(null);
  const user = useContext(UserContext);
  const auth = useContext(AuthContext);
  const [countNotification, setCountNotification] = useState(0);
  const [dialogOpen, setDialogOpen] = useState(false);
  const handleNotificationClick = () => {
    setDialogOpen(true);
  };
  const handleClose4 = () => {
    setAnchorEl1(null);
  };

  const {
    menuMobile,
    menuButton,
    menuButton1,
    divstake,
    toolbar,
    drawerContainer,
    drawericon,
    logoDrawer,
    mainHeader,
    afterLogin,
    popoverContent
  } = useStyles();

  const history = useHistory();
  const [state, setState] = useState({
    mobileView: window.innerWidth < DESKTOP_BREAKPOINT,
    drawerOpen: false,
  });

  const { mobileView, drawerOpen } = state;

  // Smooth elevation/condense as the user scrolls.
  const [scrolled, setScrolled] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 20);
    onScroll();
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  useEffect(() => {
    const setResponsiveness = () => {
      return window.innerWidth < DESKTOP_BREAKPOINT
        ? setState((prevState) => ({
            ...prevState,
            mobileView: window.innerWidth < DESKTOP_BREAKPOINT,
          }))
        : setState((prevState) => ({ ...prevState, mobileView: false }));
    };

    setResponsiveness();

    window.addEventListener("resize", () => setResponsiveness());
  }, [location]);
  const siteMode=useContext(SiteModeContext);
  const filteredHeadersData=getMenuForMode(siteMode.mode).map((item)=>({
    label:item.label,
    href:item.href,
    to:getMenuTo(item,auth.userLoggedIn),
    icon:item.icon,
    description:item.description,
  }));
  const primaryLinks=filteredHeadersData.slice(0,PRIMARY_MENU_COUNT);
  const moreLinks=filteredHeadersData.slice(PRIMARY_MENU_COUNT);
  const isMoreActive=moreLinks.some((item)=>location.pathname===item.href);
  const [moreAnchor,setMoreAnchor]=useState(null);
  const modeSwitch=siteMode.isCreator
    ?{label:"For Clients",href:"/for-clients"}
    :{label:"For Creators",href:"/for-creators"};
  const [open1, setOpen1] = useState({ community: false, user: false });
  const anchorRef = { community: useRef(null), user: useRef(null) };
  const StyledMenu = withStyles({
    paper: {
      marginTop: "2px",
    },
  })((props) => (
    <Menu
      elevation={0}
      getContentAnchorEl={null}
      anchorOrigin={{
        vertical: "bottom",
        horizontal: "center",
      }}
      transformOrigin={{
        vertical: "top",
        horizontal: "center",
      }}
      {...props}
    />
  ));

  const profileAvatarEl = auth.userData?.profilePic ? (
    <img
      src={auth.userData.profilePic}
      alt="Profile"
      className={classes.profileAvatar}
    />
  ) : auth.userData?.userType === "ORGANIZATION" &&
    auth.userData?.organizationLogo ? (
    <img
      src={auth.userData.organizationLogo}
      alt="Organization logo"
      className={classes.profileAvatar}
    />
  ) : (
    <Avatar className={`${classes.profileAvatar} ${classes.profileAvatarFallback}`}/>
  );

  const displayDesktop = () => {
    return (
      <Toolbar className={toolbar} disableGutters>
        <Box className={classes.logoCluster}>
          {femmecubatorLogo}
        </Box>
        <Box className={classes.topbarItmes}>
          <Box component="nav" className={classes.navLinks}>
            {getMenuButtons()}
          </Box>
          <Box className={classes.actionsCluster}>
          {modeSwitchButton}
          {auth.userLoggedIn ? (
            <div className={afterLogin}>
              <IconButton
                className={classes.notifyBtn}
                onClick={handleNotificationClick}
                aria-label="Notifications"
              >
                <Badge badgeContent={countNotification} color="error">
                  <FaBell />
                </Badge>
              </IconButton>
              <Notification
                setCountNotification={setCountNotification}
                open={dialogOpen}
                setOpen={setDialogOpen}
              />
              <Typography
                variant="body1"
                className={classes.menuButton}
                style={{ marginRight: "0px" }}
                onClick={() => history.push("/dashboard")}
              >
                Dashboard
              </Typography>

              <PopupState
                variant="popover"
                popupId="popup-popover0"
                className={classes.popover}
              >
                {(popupState) => (
                  <div className={classes.profileWrap}>
                    <div {...bindTrigger(popupState)}>{profileAvatarEl}</div>
                    <Popover
                      {...bindPopover(popupState)}
                      anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right",
                      }}
                      transformOrigin={{
                        vertical: "top",
                        horizontal: "right",
                      }}
                    >
                      <div className={classes.popoverContent}>
                        <Box className="icon-and-name">
                          <img src="images/profile_icon.svg" />
                          <Typography
                            variant="body2"
                            style={{ cursor: "pointer" }}
                            onClick={() => {
                              history.push("/view-profile");
                            }}
                          >
                            View Profile
                          </Typography>
                        </Box>

                        {auth?.userData?.userType == "ORGANIZATION" && (
                          <Box className="icon-and-name">
                            <img src="images/affiliatedmember_icon.svg" />
                            <Typography
                              style={{ cursor: "pointer" }}
                              variant="body2"
                              onClick={() => {
                                history.push("/affiliatedmembers");
                              }}
                            >
                              Affiliated Member
                            </Typography>
                          </Box>
                        )}

                        <Box className="icon-and-name">
                          <img src="images/reward_icon.svg" />
                          <Typography
                            style={{ cursor: "pointer" }}
                            variant="body2"
                            onClick={() => {
                              history.push("/rewards");
                            }}
                          >
                            Reward
                          </Typography>
                        </Box>

                        <Box className="icon-and-name">
                          <img src="images/settings_icon.svg" />
                          <Typography
                            style={{ cursor: "pointer" }}
                            variant="body2"
                            onClick={() => {
                              history.push("/change-password");
                            }}
                          >
                            Settings
                          </Typography>
                        </Box>

                        <Box className="icon-and-name">
                          <img src="images/logout_icon.svg" />
                          <Typography
                            style={{ cursor: "pointer" }}
                            variant="body2"
                            onClick={() => {
                              window.localStorage.removeItem("userToken");
                              window.location.reload();

                              history.push("/");
                            }}
                          >
                            Logout
                          </Typography>
                        </Box>
                      </div>
                    </Popover>
                  </div>
                )}
              </PopupState>
            </div>
          ) : (
            <Button
              variant="containedPrimary"
              className={`ecoButton ${classes.loginButton}`}
              color="secondary"
              onClick={() => {
                history.push({ pathname: "/login", state: { data: "hello" } });
              }}
            >
              Dashboard Login
            </Button>
          )}
          </Box>
          <Box className={divstake}>
            <StyledMenu
              id="simple-menu"
              disableScrollLock={true}
              anchorEl={anchorEl1}
              keepMounted
              open={Boolean(anchorEl1)}
              onClose={handleClose4}
            >
              <MenuItem
                onClick={() => {
                  history.push("/profile");
                }}
              >
                Profile
              </MenuItem>
              <MenuItem
                onClick={() => {
                  history.push("/create");
                }}
              >
                Create NFT
              </MenuItem>

              <MenuItem
                onClick={() => {
                  user.logoutHandler();
                  setAnchorEl1();
                }}
              >
                Disconnect
              </MenuItem>
            </StyledMenu>
          </Box>
        </Box>
      </Toolbar>
    );
  };

  const displayMobile = () => {
    const handleDrawerOpen = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: true }));
    const handleDrawerClose = () =>
      setState((prevState) => ({ ...prevState, drawerOpen: false }));
    //mobile
    return (
      <Toolbar className={`${toolbar} ${mainHeader}`} disableGutters>
        <Drawer
          {...{
            anchor: "right",
            open: drawerOpen,
            onClose: handleDrawerClose,
          }}
        >
          <div className={drawerContainer}>
            <Box className={classes.drawerHeader}>
              <img
                className={logoDrawer}
                src="images/kuvuma_logo.svg"
                alt="logo"
              />
              <IconButton size="small" aria-label="close menu" onClick={handleDrawerClose}>
                <CloseIcon/>
              </IconButton>
            </Box>

            {getDrawerChoices(handleDrawerClose)}

            <Box className={classes.drawerFooter}>
              {modeSwitchButton}
              {auth?.userLoggedIn?(
                <Button
                  variant="containedPrimary"
                  className={`ecoButton ${classes.loginButton}`}
                  color="secondary"
                  onClick={()=>{
                    handleDrawerClose();
                    history.push("/dashboard");
                  }}
                >
                  Dashboard
                </Button>
              ):(
                <Button
                  variant="containedPrimary"
                  className={`ecoButton ${classes.loginButton}`}
                  to="/login"
                  color="secondary"
                  component={Link}
                  onClick={handleDrawerClose}
                >
                  Dashboard Login
                </Button>
              )}
            </Box>
          </div>
        </Drawer>

        <Box className={classes.logoCluster}>
          {onMobileNavOpen&&(
            <IconButton
              className={drawericon}
              aria-label="open dashboard menu"
              onClick={onMobileNavOpen}
            >
              <MenuIcon/>
            </IconButton>
          )}
          {femmecubatorLogo}
        </Box>

        <Box className={classes.actionsCluster}>
          {auth?.userLoggedIn && (
            <div className={afterLogin}>
              <IconButton
                className={classes.notifyBtn}
                onClick={handleNotificationClick}
                aria-label="Notifications"
              >
                <Badge badgeContent={countNotification} color="error">
                  <FaBell />
                </Badge>
              </IconButton>
              <Notification
                setCountNotification={setCountNotification}
                open={dialogOpen}
                setOpen={setDialogOpen}
              />
              <div
                className={classes.profileWrap}
                onClick={() => history.push("/dashboard")}
                role="button"
                tabIndex={0}
                onKeyDown={(event) => {
                  if (event.key === "Enter" || event.key === " ") {
                    history.push("/dashboard");
                  }
                }}
              >
                {profileAvatarEl}
              </div>
            </div>
          )}

          <IconButton
            className={drawericon}
            color="inherit"
            aria-label="menu"
            aria-haspopup="true"
            onClick={handleDrawerOpen}
          >
            <MenuIcon
              width="60px"
              height="60px"
              style={{ color: "#EC1F24", fontSize: "26px" }}
            />
          </IconButton>
        </Box>
      </Toolbar>
    );
  };

  //mobile end
  const getDrawerChoices=(onNavigate)=>{
    return filteredHeadersData.map(({label,href,to,icon:Icon})=>(
      <NavLink
        exact
        key={label}
        to={to}
        isActive={()=>location.pathname===href}
        className={classes.drawerLink}
        activeClassName="active"
        onClick={onNavigate}
      >
        {Icon&&<Icon/>}
        {label}
      </NavLink>
    ));
  };

  const femmecubatorLogo = (
    <Box className={classes.logoCluster}>
      <Box className={classes.logoBox}>
        <Link to="/">
          <Logo className="logoImg" />
        </Link>
      </Box>
      {siteMode.isCreator&&(
        <Typography component="span" className={classes.modeBadge}>Creator mode</Typography>
      )}
    </Box>
  );

  const modeSwitchButton=(
    <Button
      variant="outlined"
      className={classes.modeSwitchButton}
      onClick={()=>{
        setState((prevState)=>({...prevState,drawerOpen:false}));
        history.push(modeSwitch.href);
      }}
    >
      {modeSwitch.label}
    </Button>
  );

  const getMenuButtons=()=>(
    <>
      {primaryLinks.map(({label,href,to})=>(
        <NavLink
          exact
          key={label}
          to={to}
          isActive={()=>location.pathname===href}
          className={menuButton}
          activeClassName="active"
        >
          {label}
        </NavLink>
      ))}
      {moreLinks.length>0&&(
        <>
          <Button
            className={`${menuButton}${isMoreActive?" active":""}${moreAnchor?" open":""}`}
            endIcon={<ExpandMoreIcon/>}
            aria-haspopup="true"
            aria-controls="topbar-more-menu"
            onClick={(e)=>setMoreAnchor(e.currentTarget)}
          >
            More
          </Button>
          <Menu
            id="topbar-more-menu"
            anchorEl={moreAnchor}
            open={Boolean(moreAnchor)}
            onClose={()=>setMoreAnchor(null)}
            getContentAnchorEl={null}
            anchorOrigin={{vertical:"bottom",horizontal:"right"}}
            transformOrigin={{vertical:"top",horizontal:"right"}}
            disableScrollLock
            PaperProps={{className:classes.morePaper}}
          >
            {moreLinks.map(({label,href,to,icon:Icon,description})=>(
              <MenuItem
                key={label}
                component={Link}
                to={to}
                selected={location.pathname===href}
                className={classes.moreItem}
                onClick={()=>setMoreAnchor(null)}
              >
                <span className="moreIcon">{Icon&&<Icon/>}</span>
                <Box>
                  <Typography className="moreLabel">{label}</Typography>
                  {description&&<Typography className="moreDescription">{description}</Typography>}
                </Box>
              </MenuItem>
            ))}
          </Menu>
        </>
      )}
    </>
  );

  return (
    <>
      <AppBar
        position={fixed||window.location.pathname==="/"?"fixed":"relative"}
        elevation={0}
        style={{
          backgroundColor: "#ffffff",
          borderBottom: "3px solid #FF7F26",
          padding: scrolled ? "6px 0" : "10px 0",
          overflow: "visible",
          boxShadow: scrolled
            ? "0 8px 28px -14px rgba(0, 0, 0, 0.35)"
            : "none",
          transition:
            "padding 0.35s cubic-bezier(0.22, 1, 0.36, 1), box-shadow 0.35s cubic-bezier(0.22, 1, 0.36, 1)",
        }}
      >
        <Container maxWidth={false} className={classes.barContainer}>
          {mobileView ? displayMobile() : displayDesktop()}
        </Container>
      </AppBar>
    </>
  );
}